import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import UserClasses from '../Admin/users/Users.module.css';
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import { Services } from 'Services';
import { useNavigate } from 'react-router-dom';
import { Success, Error } from 'Util/Toast';
import { Button } from '@mui/material';
import CommonTutorClasses from '../Admin/commoncssfiles/CategoryTutor.module.css';
import ReactLoading from 'react-loading';

const AddCommunities = () => {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm({
        criteriaMode: 'all',
    });
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        setLoading(true);

        const requestBody = {
            communityName: data.communityName,
            communityArea: data.communityArea,
            communityAddress: data.communityAddress,
            communityPinCode: parseInt(data.communityPinCode),
            communityLatitude: parseFloat(data.communityLatitude),
            communityLongitude: parseFloat(data.communityLongitude),
            communityStatus: parseInt(data.communityStatus), // Convert to integer
        };

        const token = { Authorization: `token ${localStorage.getItem('Token')}` };

        try {
            const response = await Services.addCommunity(requestBody, token);
            if (response.Status === 1) {
                navigate('/communities');
                Success(response.Message);
                console.log('Community added successfully:', response.Message);
            } else {
                Error(response.Message);
                console.error('Error adding community:', response.Message);
            }
        } catch (error) {
            Error('An error occurred while adding the community');
            console.error('Error adding community:', error);
        } finally {
            setLoading(false);
        }
    };

    const validateLatitude = (value) => {
        if (!value) return "Latitude is required"
        const latitude = parseFloat(value);
        return latitude >= -90 && latitude <= 90 || "Latitude must be between -90 and 90";
    };

    const validateLongitude = (value) => {
        if (!value) return "Longitude is required"
        const longitude = parseFloat(value);
        return longitude >= -180 && longitude <= 180 || "Longitude must be between -180 and 180";
    };

    return (
        <Layout Active={'Communities'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Create Community</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['add-users-btn']}>
                        <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                            BACK
                        </Button>
                    </div>
                    <div className={CommonTutorClasses['wrapper']} data-aos="zoom-in-down">
                        <h2 className={CommonTutorClasses['main-header']}>Create Community</h2>
                        <form className={CommonTutorClasses["form"]} onSubmit={handleSubmit(onSubmit)}>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityName">Community Name</label>
                                <input type='text' {...register('communityName', { required: true })} />
                                {errors.communityName && <span>This field is required</span>}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityArea">Community Area</label>
                                <input type='text' {...register('communityArea', { required: true })} />
                                {errors.communityArea && <span>This field is required</span>}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityAddress">Community Address</label>
                                <input type='text' {...register('communityAddress', { required: true })} />
                                {errors.communityAddress && <span>This field is required</span>}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityPinCode">Community Pin Code</label>
                                <input
                                    type='text'
                                    {...register('communityPinCode', {
                                        required: 'This field is required',
                                        pattern: {
                                            value: /^[1-9][0-9]{5}$/, // Regex for 6-digit pin code
                                            message: 'Invalid pin code format'
                                        }
                                    })}
                                />
                                {errors.communityPinCode && (
                                    <span>{errors.communityPinCode.message}</span>
                                )}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityLatitude">Community Latitude</label>
                                <input
                                    type='number'
                                    step='any'
                                    {...register('communityLatitude', {
                                        required: 'This field is required',
                                        validate: {
                                            validLatitude: validateLatitude,
                                        }
                                    })}
                                />
                                {errors.communityLatitude && (
                                    <span>{errors.communityLatitude.message}</span>
                                )}

                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityLongitude">Community Longitude</label>
                                <input
                                    type='number'
                                    step='any'
                                    {...register('communityLongitude', {
                                        required: 'This field is required',
                                        validate: {
                                            validLongitude: validateLongitude,
                                        }
                                    })}
                                />
                                {errors.communityLongitude && (
                                    <span>{errors.communityLongitude.message}</span>
                                )}
                            </div>
                            <div className={CommonTutorClasses['form-control']}>
                                <label htmlFor="communityStatus">Community Status</label>
                                <select {...register('communityStatus', { required: true })}>
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                                {errors.communityStatus && <span>This field is required</span>}
                            </div>
                            <button type="submit" disabled={loading}>
                                {loading ? (
                                    <ReactLoading color="green" type="spokes" height={30} width={30} />
                                ) : (
                                    'Submit'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddCommunities;
